export const contactsData = {
    email: 'goulart77matheus@gmail.com',
    phone: '5542984091682',
    phoneLabel: '42 984091682',
    address: 'Ponta Grossa - Paraná',
    sheetAPI: ''
}